import React from "react";
// import { useSelector } from "react-redux";
import "./style.css";
import { ContextMenu, ContextMenuTrigger } from "react-contextmenu";
// import { isPending } from "helpers/file";

const ReactContextMenu = ({ children, item, handleBulkSend }) => {
  // const fileStatus = useSelector(state => state.file.getActiveTab);
  // const [isBulkMenuVisible, setIsBulkMenuVisible] = useState(false);

  // useEffect(() => {
  //   if (fileStatus) {
  //     if (isPending(fileStatus)) {
  //       setIsBulkMenuVisible(true);
  //     } else {
  //       setIsBulkMenuVisible(false);
  //     }
  //   }
  // }, [fileStatus]);

  return (
    <div>
      <ContextMenuTrigger id={item.id}>{children}</ContextMenuTrigger>

      <ContextMenu preventHideOnScroll={false} hideOnLeave={true} id={item.id}>
        {/* Add to Bulk Send */}
        {/* <MenuItem
          attributes={{
            className: classnames({
              hide: item.isFile || !isBulkMenuVisible
            })
          }}
          onClick={() =>
            item.isDirectory && isBulkMenuVisible
              ? handleBulkSend([item])
              : null
          }
        >
          <i className="far fa-paper-plane mr-10"></i>
          {Translate({ id: "add_to_bulk_send" })}
        </MenuItem> */}
      </ContextMenu>
    </div>
  );
};

export default ReactContextMenu;
